import { createFileRoute, redirect } from '@tanstack/react-router';
import type { StyleDetail } from '@/api/my-styles/types';
import { StyleHierarchyVariantsTab } from '@/app/(client)/my-styles/-components/StyleHierarchyVariantsTab';
import {
  isEntityKindPath,
  styleDetailQueryOptions,
  useEntityDetail,
} from '@/app/(client)/my-styles/-hooks/useEntityDetail';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/variants',
)({
  beforeLoad: ({ params }) => {
    // Only styles have variant children — redirect any other kind back to the
    // entity's own detail.
    if (!isEntityKindPath(params.kind) || params.kind !== 'styles') {
      throw redirect({
        to: '/my-styles/$kind/$id',
        params: {
          kind: isEntityKindPath(params.kind) ? params.kind : 'styles',
          id: params.id,
        },
      });
    }
  },
  loader: ({ params }) =>
    queryClient.ensureQueryData(styleDetailQueryOptions(params.id)),
  component: StyleVariantsSubtabRoute,
});

function StyleVariantsSubtabRoute() {
  const { id } = Route.useParams();
  const { data: entity } = useEntityDetail('styles', id);
  const styleName = (entity as StyleDetail | undefined)?.name ?? '';
  return <StyleHierarchyVariantsTab styleId={id} styleName={styleName} />;
}
